var _IntegerColumnFormatter;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint class-methods-use-this: "off" */

import Log from '@deephaven/log';
import TableColumnFormatter from "./TableColumnFormatter.js";
var log = Log.module('IntegerColumnFormatter');
/** Column formatter for integers/whole numbers */
export class IntegerColumnFormatter extends TableColumnFormatter {
  /**
   * Validates format object
   * @param dh JSAPI instance
   * @param format Format object
   * @returns true for valid object
   */
  static isValid(dh, format) {
    if (format.formatString == null) {
      return false;
    }
    try {
      dh.i18n.NumberFormat.format(format.formatString, 0);
      return true;
    } catch (e) {
      return false;
    }
  }

  /**
   * Create an IntegerColumnFormat object with the parameters specified
   * @param label Label for the format
   * @param formatString Format string for the format
   * @param multiplier Optional multiplier for the formatter
   * @param type Type of format created
   * @returns IntegerColumnFormat object
   */
  static makeFormat(label, formatString) {
    var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : TableColumnFormatter.TYPE_CONTEXT_PRESET;
    var multiplier = arguments.length > 3 ? arguments[3] : undefined;
    return {
      label,
      type,
      formatString,
      multiplier
    };
  }

  /**
   * Convenient function to create a IntegerFormatObject with Preset type set
   * @param label Label for this format object
   * @param formatString Format string to use
   * @param multiplier Multiplier to use
   * @returns IntegerColumnFormat object
   */
  static makePresetFormat(label) {
    var formatString = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var multiplier = arguments.length > 2 ? arguments[2] : undefined;
    return IntegerColumnFormatter.makeFormat(label, formatString, TableColumnFormatter.TYPE_CONTEXT_PRESET, multiplier);
  }

  /**
   * Convenient function to create a IntegerFormatObject with a default 'Custom Format' label and Custom type
   * @param formatString Format string to use
   * @param multiplier Multiplier to use
   * @returns IntegerColumnFormat object
   */
  static makeCustomFormat() {
    var formatString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var multiplier = arguments.length > 1 ? arguments[1] : undefined;
    return IntegerColumnFormatter.makeFormat('Custom Format', formatString, TableColumnFormatter.TYPE_CONTEXT_CUSTOM, multiplier);
  }

  /**
   * Check if the given formats match
   * @param formatA format object to check
   * @param formatB format object to check
   * @returns True if the formats match
   */
  static isSameFormat(formatA, formatB) {
    return formatA === formatB || formatA != null && formatB != null && formatA.type === formatB.type && formatA.formatString === formatB.formatString && formatA.multiplier === formatB.multiplier;
  }
  constructor(dh) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$defaultFormatStr = _ref.defaultFormatString,
      defaultFormatString = _ref$defaultFormatStr === void 0 ? IntegerColumnFormatter.DEFAULT_FORMAT_STRING : _ref$defaultFormatStr;
    super();
    _defineProperty(this, "dh", void 0);
    _defineProperty(this, "defaultFormatString", void 0);
    this.dh = dh;
    this.defaultFormatString = defaultFormatString;
  }

  /**
   * Format a value with the provided format object
   * @param valueParam Value to format
   * @param format Format object
   * @returns Formatted string
   */
  format(valueParam) {
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var formatString = format.formatString != null && format.formatString !== '' ? format.formatString : this.defaultFormatString;
    var value = format.multiplier != null && format.multiplier !== 0 ? valueParam * format.multiplier : valueParam;
    try {
      return this.dh.i18n.NumberFormat.format(formatString, value);
    } catch (e) {
      log.error('Invalid format arguments');
    }
    return '';
  }
}
_IntegerColumnFormatter = IntegerColumnFormatter;
_defineProperty(IntegerColumnFormatter, "DEFAULT_FORMAT_STRING", '###,##0');
_defineProperty(IntegerColumnFormatter, "FORMAT_THOUSANDS", _IntegerColumnFormatter.makePresetFormat('Thousands', '##0.000 k', 0.001));
_defineProperty(IntegerColumnFormatter, "FORMAT_MILLIONS", _IntegerColumnFormatter.makePresetFormat('Millions', '###,##0.000 mm', 0.000001));
_defineProperty(IntegerColumnFormatter, "FORMAT_SCIENTIFIC_NOTATION", _IntegerColumnFormatter.makePresetFormat('Scientific Notation', '0.0000E0'));
export default IntegerColumnFormatter;
//# sourceMappingURL=IntegerColumnFormatter.js.map